(function () {
  var root = document.documentElement;
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function money(cents) {
    var f = (window.SCX && window.SCX.money) || '£{{amount}}';
    return f.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, (cents / 100).toFixed(2).replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/<[^>]+>/g, '');
  }
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveals ---------- */
  var io = null;
  function reveal() {
    var els = $$('[data-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (list) {
        list.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    }
    els.forEach(function (e) {
      var p = e.parentElement, i = 0;
      if (e.hasAttribute('data-stagger') && p) { i = Array.prototype.indexOf.call(p.children, e) % 4; e.style.setProperty('--d', (i * 0.07) + 's'); }
      io.observe(e);
    });
  }

  /* ---------- header ---------- */
  var hd = $('.sc-header');
  function onScroll() { if (hd) hd.classList.toggle('is-scrolled', window.scrollY > 8); }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* ---------- product cards ---------- */
  function cs(card) {
    if (card._s) return card._s;
    var v = [], c = [], im = [];
    try { v = JSON.parse(card.getAttribute('data-v') || '[]'); c = JSON.parse(card.getAttribute('data-c') || '[]'); im = JSON.parse(card.getAttribute('data-imgs') || '[]'); } catch (e) {}
    var first = null;
    for (var i = 0; i < v.length; i++) { if (v[i].a) { first = v[i]; break; } }
    card._s = { v: v, c: c, im: im, idx: 0, hasColor: c.length > 0, hasSize: !!card.querySelector('.pc__size'), color: first ? first.c : (c[0] ? c[0].n : '') };
    return card._s;
  }
  function cardVariant(card) {
    var s = cs(card);
    for (var i = 0; i < s.v.length; i++) { if (!s.hasColor || s.v[i].c === s.color) return s.v[i]; }
    return s.v[0] || null;
  }
  function cardRender(card) {
    var s = cs(card);
    $$('.pc__size', card).forEach(function (b) {
      var v = null;
      s.v.forEach(function (x) { if ((!s.hasColor || x.c === s.color) && x.s === b.getAttribute('data-s')) v = x; });
      b.removeAttribute('data-sc-add');
      if (v && v.a) { b.disabled = false; b.setAttribute('data-sc-add', v.id); } else { b.disabled = true; }
    });
    var one = $('.pc__one', card);
    if (one) {
      var v1 = cardVariant(card); one.removeAttribute('data-sc-add');
      if (v1 && v1.a) { one.disabled = false; one.textContent = 'Add to cart'; one.setAttribute('data-sc-add', v1.id); } else { one.disabled = true; one.textContent = 'Sold out'; }
    }
    $$('.pc__dot', card).forEach(function (d) { d.classList.toggle('on', d.getAttribute('data-c') === s.color); });
    var nm = $('.pc__cname', card); if (nm) nm.textContent = s.color;
  }
  function cardImg(card, src) {
    var img = $('.pc__img--a', card); if (!img || !src) return;
    img.removeAttribute('srcset'); img.src = src;
    var m = $('.pc__media', card); if (m) m.classList.add('manual');
  }
  function cardInit(card) { if (card._init) return; card._init = true; cardRender(card); }
  function initCards() { $$('.pc').forEach(cardInit); }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('.pc');
    if (!card) return;
    var s = cs(card);
    var dot = e.target.closest('.pc__dot');
    if (dot) { e.preventDefault(); s.color = dot.getAttribute('data-c'); cardImg(card, dot.getAttribute('data-i')); cardRender(card); return; }
    var arr = e.target.closest('.pc__arr');
    if (arr) {
      e.preventDefault();
      if (s.im.length > 1) { s.idx = (s.idx + (arr.classList.contains('pc__arr--n') ? 1 : -1) + s.im.length) % s.im.length; cardImg(card, s.im[s.idx]); }
      return;
    }
    if (e.target.closest('.pc__qa-toggle')) { card.classList.add('qa-open'); return; }
    if (e.target.closest('[data-sc-add]')) { setTimeout(function () { card.classList.remove('qa-open'); }, 300); }
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('.pc')) return;
    $$('.pc.qa-open').forEach(function (c) { c.classList.remove('qa-open'); });
  });

  /* ---------- product page ---------- */
  var pdpEl = $('[data-pdp]');
  var lb = $('#sc-lb');
  var lbList = [], lbI = 0;
  function lbShow(i) {
    lbI = (i + lbList.length) % lbList.length;
    var st = $('.lb__stage', lb); st.classList.remove('zoomed');
    $('img', st).src = lbList[lbI];
    $('.lb__count', lb).textContent = (lbI + 1) + ' / ' + lbList.length;
  }
  function lbOpen(i) {
    lb.classList.add('on'); lb.classList.toggle('single', lbList.length < 2);
    document.body.classList.add('sc-locked'); lbShow(i);
  }
  function lbClose() { lb.classList.remove('on'); document.body.classList.remove('sc-locked'); }

  if (pdpEl) {
    var data = JSON.parse($('[data-pdp-json]').textContent);
    var form = $('#sc-product-form'), idEl = $('#sc-variant-id'), addBtn = $('#sc-add'), priceEl = $('#sc-price');
    var items = $$('.gal__item', pdpEl);
    lbList = items.map(function (a) { return a.getAttribute('data-full'); });

    items.forEach(function (it, i) { it.addEventListener('click', function () { if (lb && lbList[i]) lbOpen(i); }); });

    var main = $('.gal__main', pdpEl), dots = $$('.gal__dots i', pdpEl);
    if (main && dots.length) {
      main.addEventListener('scroll', function () {
        var i = Math.round(main.scrollLeft / main.clientWidth);
        dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      }, { passive: true });
    }

    function chosen() {
      var out = [];
      $$('input[type=radio]:checked', form).forEach(function (r) { out[parseInt(r.name.replace('option', ''), 10) - 1] = r.value; });
      return out;
    }
    function find(sel) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var k = 0; k < 3; k++) { if (sel[k] !== undefined && sel[k] !== null && v['o' + (k + 1)] !== sel[k]) ok = false; }
        if (ok) return v;
      }
      return null;
    }
    function pdpRender(scroll) {
      var sel = chosen(), v = find(sel);
      $$('[data-opt-lbl]', form).forEach(function (l) {
        var p = parseInt(l.getAttribute('data-opt-lbl'), 10);
        l.textContent = sel[p - 1] || '';
      });
      $$('input[type=radio]', form).forEach(function (r) {
        var p = parseInt(r.name.replace('option', ''), 10) - 1;
        var any = false;
        data.variants.forEach(function (x) {
          var ok = true;
          if (x['o' + (p + 1)] !== r.value) ok = false;
          for (var k2 = 0; k2 < 3; k2++) { if (k2 !== p && sel[k2] !== undefined && x['o' + (k2 + 1)] !== sel[k2] && data.kinds[k2] === 'color') ok = false; }
          if (ok && x.a) any = true;
        });
        r.parentNode.classList.toggle('is-out', !any);
      });
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
      idEl.value = v.id;
      if (priceEl) priceEl.innerHTML = (v.cp && v.cp > v.p ? '<s>' + money(v.cp) + '</s>' : '') + money(v.p);
      addBtn.disabled = !v.a;
      addBtn.textContent = v.a ? data.add : data.out;
      var bb = $('#pdp-bar-btn'); if (bb) { bb.disabled = !v.a; bb.textContent = v.a ? data.add : data.out; }
      var bp = $('#pdp-bar-price'); if (bp) bp.textContent = money(v.p);
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
      if (scroll && v.m) {
        var tgt = $('.gal__item[data-mid="' + v.m + '"]', pdpEl);
        if (tgt) {
          if (main && main.scrollWidth > main.clientWidth + 4) main.scrollTo({ left: tgt.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
          else { var r = tgt.getBoundingClientRect(); if (r.top < 0 || r.top > innerHeight * 0.6) window.scrollTo({ top: r.top + scrollY - 100, behavior: reduce ? 'auto' : 'smooth' }); }
        }
      }
    }
    form.addEventListener('change', function (e) { if (e.target.type === 'radio') pdpRender(true); });
    pdpRender(false);

    var qty = $('[name=quantity]', form);
    form.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty]'); if (!b || !qty) return;
      var n = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10);
      qty.value = Math.max(1, n);
    });

    var barBtn = $('#pdp-bar-btn'), bar = $('.pdp-bar');
    if (barBtn) barBtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else addBtn.click(); });
    if (bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (l) { bar.classList.toggle('on', !l[0].isIntersecting && l[0].boundingClientRect.top < 0); }).observe(addBtn);
    }
  }

  if (lb) {
    lb.addEventListener('click', function (e) {
      if (e.target.closest('.lb__x')) lbClose();
      else if (e.target.closest('.lb__nav--p')) lbShow(lbI - 1);
      else if (e.target.closest('.lb__nav--n')) lbShow(lbI + 1);
      else if (e.target.closest('.lb__stage img')) $('.lb__stage', lb).classList.toggle('zoomed');
    });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('on')) return;
      if (e.key === 'Escape') lbClose();
      if (e.key === 'ArrowLeft') lbShow(lbI - 1);
      if (e.key === 'ArrowRight') lbShow(lbI + 1);
    });
    var tx = 0;
    lb.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if ($('.lb__stage', lb).classList.contains('zoomed')) return;
      var dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 50) lbShow(lbI + (dx < 0 ? 1 : -1));
    });
  }

  function boot() { initCards(); reveal(); root.classList.add('sc-ready'); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { initCards(); reveal(); });
})();
